function convertTickerClassificationResourceToChartData(tickerClassification) {
  return {
    name: tickerClassification.attr('label'),
    value: Number(tickerClassification.attr('value')),
    color: tickerClassification.attr('color'),
    type: tickerClassification.attr('type'), // types of ticker corresponds to labels of classification
  };
}

function convertAssetClassChartDataResourceToChartData(classification) {
  return {
    type: classification.attr('type'),
    label: classification.attr('label'),
    name: `${classification.attr('percentageValue')} ${classification.attr('label')}`,
    value: parseFloat(classification.attr('percentageValue')),
    color: classification.attr('color'),
    tickerClassifications: [], // we will associate the ticker classifications here
  };
}

export default function useManagedAccountPortfolio({
  portfolio,
}) {
  // build list of ticker classifications
  const tickerClassifications = portfolio?.attr('categoryChartData').resources().list()
    .map(convertTickerClassificationResourceToChartData)
    .sort((a, b) => b.value - a.value);

  // build list of higher level classifications
  const classifications = portfolio?.attr('assetClassChartData').resources().list()
    .map(convertAssetClassChartDataResourceToChartData)
    .filter(classification => !!classification.value && !!classification.type && (classification.value >= 5));

  // map labels to classifications by reference
  const classificationsByLabel = classifications.reduce((acc, curr) => ({ ...acc, [curr.label]: curr }), {});

  // associate ticker classifications to their higher level classification
  for (const tickerClassification of tickerClassifications) {
    if (tickerClassification.type in classificationsByLabel) {
      classificationsByLabel[tickerClassification.type].tickerClassifications.push(tickerClassification);
    }
  }

  // build list of ticket classifications grouped by allocation model classification
  const tickerClassificationsGrouped = classifications.reduce((acc, curr) => [...acc, ...curr.tickerClassifications], []);

  return {
    classifications,
    tickerClassifications,
    tickerClassificationsGrouped,
  };
}
